export default __webpack_public_path__ + "fd7c33128e9d6290ab6a8a4d839d9c9a.png";